/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import {
  FETCH_DELETED_APPLICATIONS_REQUEST,
  FETCH_DELETED_APPLICATIONS_SUCCESS,
  FETCH_DELETED_APPLICATIONS_FAILURE,
} from "./DeletedApplicationsTypes";

const initialState = {
  loading: false,
  deletedApplications: [],
  error: "",
};

const deletedApplicationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DELETED_APPLICATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case FETCH_DELETED_APPLICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        deletedApplications: action.payload,
        error: "",
      };
    case FETCH_DELETED_APPLICATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        deletedApplications: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default deletedApplicationsReducer;
